export const loadUserState = () => {
  try {
    const serializedState = localStorage.getItem('userState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (e) {
    return undefined;
  }
};

export const saveUserState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('userState', serializedState);
  } catch (e) {
    // ignore write errors
  }
};
